module.exports = __webpack_public_path__ + "img/nexultra-O-100.3cb5f29a.png";